<template>
  <div class="home-page">
    <!-- 全屏轮播图 -->
    <section class="hero-section">
      <el-carousel height="600px" :interval="5000" arrow="always">
        <el-carousel-item v-for="(slide, index) in carouselSlides" :key="index">
          <div class="carousel-content" :style="{ backgroundImage: `url(${slide.image})` }">
            <div class="overlay"></div>
            <div class="carousel-caption">
              <h2 class="slide-subtitle animate__animated animate__fadeInDown">{{ slide.subtitle }}</h2>
              <h1 class="slide-title animate__animated animate__fadeInUp">{{ slide.title }}</h1>
              <el-button
                  class="slide-button animate__animated animate__fadeInUp"
                  type="primary"
                  size="large"
                  @click="navigateTo(slide.buttonLink)"
              >
                {{ slide.buttonText }}
              </el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- 主要业务领域 -->
    <section class="business-areas">
      <div class="page-container">
        <div class="business-grid">
          <div
              v-for="(area, index) in businessAreas"
              :key="index"
              class="business-card"
              @click="navigateTo(area.link)"
          >
            <div class="business-icon">
              <i :class="area.icon"></i>
            </div>
            <h3>{{ area.title }}</h3>
            <p>{{ area.description }}</p>
            <div class="business-hover">
              <span>{{ $t('common.more') }} <i class="el-icon-arrow-right"></i></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 正在发生 (新闻动态) -->
    <section class="news-section">
      <div class="page-container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('home.newsSectionTitle') }}</h2>
        </div>
        <div class="news-content">
          <div class="main-news" v-if="newsList.length > 0">
            <div class="main-news-item" @click="viewNewsDetail(newsList[0]._id)">
              <div class="news-image">
                <img :src="newsList[0].cover || require('@/assets/images/news/news-placeholder.jpg')"
                     :alt="newsList[0].title">
              </div>
              <div class="news-info">
                <h3>{{ newsList[0].title }}</h3>
                <p>{{ getSummary(newsList[0].content, 120) }}</p>
                <div class="news-meta">
                  <span class="date">{{ formatDate(newsList[0].editTime) }}</span>
                  <span class="read-more">{{ $t('home.readFull') }} <i class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>

          <div class="sub-news">
            <div
                v-for="(item, index) in newsList.slice(1, 5)"
                :key="index"
                class="sub-news-item"
                @click="viewNewsDetail(item._id)"
            >
              <div class="news-info">
                <h3>{{ item.title }}</h3>
                <div class="news-meta">
                  <span class="date">{{ formatDate(item.editTime) }}</span>
                  <span class="read-more">{{ $t('home.readFull') }} <i class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="news-more">
          <router-link :to="$lp('/news')" class="more-link">{{ $t('home.exploreMore') }} <i class="el-icon-arrow-right"></i></router-link>
        </div>
      </div>
    </section>

    <!-- 公司介绍视频 -->
    <section class="video-section">
      <div class="page-container">
        <div class="video-container">
          <div class="video-text">
            <h2>{{ $t('home.videoTitle') }}</h2>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('home.videoDesc') }}</p>
            <router-link :to="$lp('/about')" class="video-link">{{ $t('common.more') }} <i class="el-icon-arrow-right"></i></router-link>
          </div>
          <div class="video-player">
            <div class="video-wrapper">
              <video
                  ref="videoPlayer"
                  controls
                  autoplay
                  muted
                  playsinline style="width: 100%; height: 350px;"
                  poster="@/assets/images/logo/logo2.png"
              >
                <source src="@/assets/video/01.mp4" type="video/mp4">
                {{ $t('home.videoNotSupported') }}
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 加入我们 -->
    <section class="join-section">
      <div class="page-container">
        <div class="join-container">
          <div class="join-content">
            <h2 style="color: white">{{ $t('home.joinTitle') }}</h2>
            <h3 style="color: white">{{ $t('home.joinSubtitle') }}</h3>
            <p>{{ $t('home.joinDesc') }}</p>
            <router-link :to="$lp('/recruits')" class="join-link">{{ $t('home.joinUs') }} <i class="el-icon-arrow-right"></i></router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计 -->
    <div class="statistics-section">
      <div class="page-container">
        <div class="section-header text-center">
          <h2 class="section-title">{{ $t('home.clientsTitle') }}</h2>
          <!--          <p class="section-desc">景天下致力于成为行业领导者，以下是我们的一些成就数据</p>-->
        </div>
        <div class="statistics-container" v-loading="statisticsLoading">
          <div class="statistic-item" v-for="(item, index) in statisticsData" :key="index">
            <div class="statistic-icon">
              <!--              <i :class="item.icon"></i>-->
              <img :src="item.icon" alt="">
            </div>
            <!--            <div class="statistic-number">-->
            <!--              <CountTo-->
            <!--                  :start-val="0"-->
            <!--                  :end-val="item.value"-->
            <!--                  :duration="2500"-->
            <!--                  :decimals="item.decimals || 0"-->
            <!--                  separator=","-->
            <!--              />-->
            <!--              <span class="statistic-unit" v-if="item.unit">{{ item.unit }}</span>-->
            <!--            </div>-->
            <!--            <div class="statistic-title">{{ item.title }}</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, computed} from 'vue';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';
import {formatDate, getSummary} from '@/utils/helper';
import {getOverview} from '@/api/statistics';
import {useNewsData} from '@/composables/useNewsData';
import {localePath} from '@/utils/locale';
import CountTo from '@/components/CountTo.vue';

export default {
  name: 'HomeView',
  components: {
    CountTo
  },
  setup() {
    const router = useRouter();
    const {t, locale} = useI18n();
    // 首页新闻：与新闻列表页共用同一数据源（useNewsData 按语言切换静态数据）
    // 取前 5 条：1 条主新闻 + 4 条副新闻（按 editTime 倒序已在数据内维护）
    const {items: newsItems} = useNewsData();
    const newsList = computed(() => newsItems.value.slice(0, 5));
    const statisticsData = ref([]);
    const statisticsLoading = ref(false);
    const showVideoModal = ref(false);
    const videoPlayer = ref(null);

    // 格式化当前时间
    const currentTime = computed(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    });

    // 轮播图数据（文案随语言切换）
    const carouselSlides = computed(() => [
      {
        title: t('home.carousel1Title'),
        subtitle: t('home.carousel1Subtitle'),
        buttonText: t('common.more'),
        buttonLink: '/about',
        image: require('@/assets/images/banner/banner01.jpg')
      },
      {
        title: t('home.carousel2Title'),
        subtitle: t('home.carousel2Subtitle'),
        buttonText: t('home.carousel2Button'),
        buttonLink: '/boxs',
        image: require('@/assets/images/banner/banner04.jpg')
      },
      {
        title: t('home.carousel3Title'),
        subtitle: t('home.carousel3Subtitle'),
        buttonText: t('home.joinUs'),
        buttonLink: '/recruits',
        image: require('@/assets/images/banner/banner05.jpg')
      }
    ]);

    // 业务领域数据（文案随语言切换）
    const businessAreas = computed(() => [
      {
        title: t('home.area1Title'),
        description: t('home.area1Desc'),
        icon: 'el-icon-s-opportunity',
        // link: '/boxs/software'
        link: '#'
      },
      {
        title: t('home.area2Title'),
        description: t('home.area2Desc'),
        icon: 'el-icon-s-cooperation',
        // link: '/boxs/integration'
        link: '#'
      },
      {
        title: t('home.area3Title'),
        description: t('home.area3Desc'),
        icon: 'el-icon-s-management',
        // link: '/boxs/consulting'
        link: '#'
      },
      {
        title: t('home.area4Title'),
        description: t('home.area4Desc'),
        icon: 'el-icon-s-platform',
        // link: '/boxs/solutions'
        link: '#'
      }
    ]);

    // 获取统计数据
    const fetchStatistics = async () => {
      statisticsLoading.value = true;
      try {
        const res = await getOverview();
        if (res.data && res.data.ActionType === 'ok') {
          const data = res.data.data;
          statisticsData.value = [
            {title: '客户数量', value: data?.clientCount || 1000, icon: require('@/assets/images/customer/01.png')},
            {title: '服务项目', value: data?.projectCount || 500, icon: require('@/assets/images/customer/02.png')},
            {title: '团队成员', value: data?.teamCount || 120, icon: require('@/assets/images/customer/03.png')},
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/04.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/05.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/06.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/07.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/08.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/09.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/10.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/11.png')
            },
            {
              title: '客户满意度',
              value: data?.satisfaction || 98,
              unit: '%',
              icon: require('@/assets/images/customer/12.png')
            }
          ];
        }
      } catch (error) {
        console.error('获取统计数据失败:', error);
        // 设置默认数据
        statisticsData.value = [
          {title: '客户数量', value: 1000, icon: 'el-icon-user'},
          {title: '服务项目', value: 500, icon: 'el-icon-s-grid'},
          {title: '团队成员', value: 120, icon: 'el-icon-s-custom'},
          {title: '客户满意度', value: 98, unit: '%', icon: 'el-icon-star-on'}
        ];
      } finally {
        statisticsLoading.value = false;
      }
    };

    // 页面导航（站内路径按当前语言加前缀，'#' 等占位链接保持原样）
    const navigateTo = (path) => {
      router.push(path.startsWith('/') ? localePath(path, locale.value) : path);
    };

    // 查看新闻详情（按当前语言生成路径）
    const viewNewsDetail = (id) => {
      router.push(localePath(`/news/${id}`, locale.value));
    };

    // 播放视频
    const playVideo = () => {
      // 这里可以实现视频播放逻辑，如弹出视频播放器模态框
      showVideoModal.value = true;
    };

    // 关闭视频模态框
    const closeVideoModal = () => {
      showVideoModal.value = false;
      // 停止视频播放
      if (videoPlayer.value) {
        videoPlayer.value.pause();
        videoPlayer.value.currentTime = 0;
      }
    };

    onMounted(() => {
      fetchStatistics();
    });

    return {
      carouselSlides,
      businessAreas,
      newsList,
      currentTime,
      formatDate,
      getSummary,
      navigateTo,
      viewNewsDetail,
      showVideoModal,
      videoPlayer,
      playVideo,
      closeVideoModal,
      statisticsData,
      statisticsLoading
    };
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  .hero-section {
    margin-top: 0;
    position: relative;

    .carousel-content {
      height: 100%;
      background-position: center;
      background-size: cover;
      position: relative;

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
      }

      .carousel-caption {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        width: 80%;
        max-width: 800px;
        z-index: 2;

        .slide-subtitle {
          font-size: 28px;
          font-weight: 500;
          margin-bottom: 15px;
          letter-spacing: 1px;
          //color: #2E7D32;
          color: white;
        }

        .slide-title {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 30px;
          line-height: 1.2;
          //color: #2E7D32;
          color: white;
        }

        .slide-button {
          padding: 12px 30px;
          font-size: 16px;
          font-weight: 500;
          background-color: #163C7D;
          border-color: #163C7D;

          &:hover {
            background-color: darken(#163C7D, 10%);
            border-color: darken(#163C7D, 10%);
          }
        }
      }
    }
  }

  .business-areas {
    padding: 80px 0;
    background-color: #f9f9f9;

    .business-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }

      .business-card {
        background-color: white;
        padding: 40px 30px;
        border-radius: 8px;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

          .business-hover {
            bottom: 0;
          }
        }

        .business-icon {
          margin-bottom: 20px;

          i {
            font-size: 48px;
            color: #163C7D;
          }
        }

        h3 {
          font-size: 22px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        p {
          font-size: 15px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .business-hover {
          position: absolute;
          bottom: -50px;
          left: 0;
          width: 100%;
          background-color: #163C7D;
          color: white;
          padding: 12px 0;
          transition: all 0.3s ease;
          font-weight: 500;

          span {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
          }
        }
      }
    }
  }

  .news-section {
    padding: 80px 0;

    .section-header {
      text-align: center;
      margin-bottom: 50px;

      .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #163C7D;
        position: relative;
        display: inline-block;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -15px;
          width: 60px;
          height: 3px;
          background-color: #163C7D;
          transform: translateX(-50%);
        }
      }
    }

    .news-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 30px;
      margin-bottom: 40px;

      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }

      .main-news {
        .main-news-item {
          background-color: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          }

          .news-image {
            height: 300px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.5s ease;

              &:hover {
                transform: scale(1.05);
              }
            }
          }

          .news-info {
            padding: 30px;

            h3 {
              font-size: 22px;
              font-weight: 600;
              color: #333;
              margin-bottom: 15px;
              line-height: 1.4;
            }

            p {
              font-size: 15px;
              color: #666;
              margin-bottom: 20px;
              line-height: 1.6;
            }

            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .date {
                color: #999;
                font-size: 14px;
              }

              .read-more {
                color: #163C7D;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
              }
            }
          }
        }
      }

      .sub-news {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .sub-news-item {
          background-color: white;
          border-radius: 8px;
          padding: 25px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateX(5px);
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          }

          .news-info {
            h3 {
              font-size: 18px;
              font-weight: 600;
              color: #333;
              margin-bottom: 15px;
              line-height: 1.4;

              // 两行文本溢出省略
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .news-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .date {
                color: #999;
                font-size: 14px;
              }

              .read-more {
                color: #163C7D;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
              }
            }
          }
        }
      }
    }

    .news-more {
      text-align: center;

      .more-link {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #163C7D;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        padding: 10px 20px;
        border: 1px solid #163C7D;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
          background-color: #163C7D;
          color: white;
        }
      }
    }
  }

  .video-section {
    padding: 80px 0;
    background-color: #f5f5f5;

    .video-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 50px;
      align-items: center;

      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }

      .video-text {
        h2 {
          font-size: 36px;
          font-weight: 700;
          color: #163C7D;
          margin-bottom: 20px;
          line-height: 1.3;
        }

        p {
          font-size: 16px;
          color: #666;
          margin-bottom: 30px;
          line-height: 1.7;
        }

        .video-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #163C7D;
          font-size: 16px;
          font-weight: 500;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .video-player {
        .video-placeholder {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          cursor: pointer;

          img {
            width: 100%;
            height: 350px;
            object-fit: cover;
          }

          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80px;
            height: 80px;
            background-color: rgba(22, 60, 125, 0.8);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            i {
              font-size: 40px;
              color: white;
            }

            &:hover {
              background-color: rgba(22, 60, 125, 1);
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
      }
    }
  }

  .join-section {
    padding: 100px 0;
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('~@/assets/images/about/b01.jpg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;

    .join-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .join-content {
        text-align: center;
        color: white;
        max-width: 700px;

        h2 {
          font-size: 42px;
          font-weight: 700;
          margin-bottom: 15px;
        }

        h3 {
          font-size: 28px;
          font-weight: 500;
          margin-bottom: 20px;
        }

        p {
          font-size: 16px;
          margin-bottom: 30px;
          line-height: 1.7;
          opacity: 0.9;
        }

        .join-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background-color: #163C7D;
          color: white;
          padding: 12px 30px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s ease;

          &:hover {
            background-color: lighten(#163C7D, 10%);
            transform: translateY(-3px);
          }
        }
      }
    }
  }

  .stock-section {
    padding: 40px 0;

    .stock-container {
      display: flex;
      justify-content: center;

      .stock-item {
        background-color: #f9f9f9;
        padding: 20px 40px;
        border-radius: 8px;
        text-align: center;

        .stock-name {
          font-size: 18px;
          font-weight: 600;
          color: #163C7D;
          margin-bottom: 10px;
        }

        .stock-price {
          font-size: 24px;
          font-weight: 700;
          color: #333;
          margin-bottom: 5px;

          .up {
            color: #ff4d4f;
            font-size: 16px;
          }
        }

        .stock-time {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }

  .statistics-section {
    background-color: #f5f7fa;
    padding: 10px 0;

    .statistics-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      margin-top: 50px;

      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }

      .statistic-item {
        background-color: #fff;
        border-radius: 8px;
        padding-top: 10px;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s, box-shadow 0.3s;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .statistic-icon {
          font-size: 10px;
          color: #409EFF;
          margin-bottom: 1px;
        }

        .statistic-number {
          font-size: 36px;
          font-weight: 700;
          color: #303133;
          margin-bottom: 10px;

          .statistic-unit {
            font-size: 20px;
            margin-left: 5px;
          }
        }

        .statistic-title {
          font-size: 16px;
          color: #606266;
        }
      }
    }
  }
}
</style>